import AdminMeds from "@/assets/icons/admin_meds.svg?react";
import BarChart from "@/assets/icons/bar_chart_4_bars.svg?react";
import BloodPressure from "@/assets/icons/blood_pressure.svg?react";
import BreakingNews from "@/assets/icons/breaking_news.svg?react";
import Checklist from "@/assets/icons/checklist.svg?react";
import ClinicalNotes from "@/assets/icons/clinical_notes.svg?react";
import ContentPasteSearch from "@/assets/icons/content_paste_search.svg?react";
import DatabaseSearch from "@/assets/icons/database_search.svg?react";
import Demography from "@/assets/icons/demography.svg?react";
import Ecg from "@/assets/icons/ecg.svg?react";
import Flag from "@/assets/icons/flag.svg?react";
import FrameInspect from "@/assets/icons/frame_inspect.svg?react";
import GroupSearch from "@/assets/icons/group_search.svg?react";
import HealthMetrics from "@/assets/icons/health_metrics.svg?react";
import LabProfile from "@/assets/icons/lab_profile.svg?react";
import LabResearch from "@/assets/icons/lab_research.svg?react";
import MapSearch from "@/assets/icons/map_search.svg?react";
import Medication from "@/assets/icons/medication.svg?react";
import PillOff from "@/assets/icons/pill_off.svg?react";
import Plagiarism from "@/assets/icons/plagiarism.svg?react";
import Prescription from "@/assets/icons/prescriptions.svg?react";
import Procedure from "@/assets/icons/procedure.svg?react";
import QuickReference from "@/assets/icons/quick_reference.svg?react";
import Radar from "@/assets/icons/radar.svg?react";
import ReduceCapacity from "@/assets/icons/reduce_capacity.svg?react";
import Rubric from "@/assets/icons/rubric.svg?react";
import Signature from "@/assets/icons/signature.svg?react";
import TextCompare from "@/assets/icons/text_compare.svg?react";
import Troubleshoot from "@/assets/icons/troubleshoot.svg?react";
import MotionSensorUrgent from "@/assets/icons/motion_sensor_urgent.svg?react";

export const CATEGORY_ICONS = {
  "Analyze Lab Trends Over Time": Rubric,
  "Analyze Lab, Assessment, and Questionnaire Data by Subgroup": LabResearch,
  "Analyze Visit-Level Changes and Trends": TextCompare,
  "Assess AE Severity, Duration, and Causality": BreakingNews,
  "Assess Impact of Eligibility Criteria": Checklist,
  "Build Risk-Based Participant Cohorts": ReduceCapacity,
  "Ensure Informed Consent Compliance": Signature,
  "Evaluate AE Patterns Over Time": BloodPressure,
  "Evaluate Clinical Endpoints": Rubric,
  "Evaluate COA/PRO Scores": ContentPasteSearch,
  "Evaluate Drug Exposure and Concomitant Medications": Medication,
  "Evaluate Safety by Subgroup": GroupSearch,
  "Evaluate Screening Effectiveness Across Sites": MapSearch,
  "Explore Relationships Between Clinical Measures": HealthMetrics,
  "Identify AE Hotspots by Site or Subgroup": FrameInspect,
  "Identify Out-of-Range Lab Values": Radar,
  "Investigate Protocol Deviations and Root Causes": Procedure,
  "Monitor and Evaluate Safety Events and Signals": Ecg,
  "Monitor Dosing and Intervention Adherence": AdminMeds,
  "Monitor Enrollment and Retention": BarChart,
  "Monitor Patient Safety Risks from Abnormal Values": MotionSensorUrgent,
  "Oversee & Optimize Site Performance": Troubleshoot,
  "Oversee Study Milestones and Subject Journeys": Flag,
  "Retrieve Protocol-Specific Information": Plagiarism,
  "Review Individual Participant Data": ClinicalNotes,
  "Summarize Adverse Events and Serious Adverse Events": QuickReference,
  "Summarize Key Lab Results": LabProfile,
  "Summarize Participant Demographics": Demography,
  "Track Concomitant Medications": Prescription,
  "Track Missed or Delayed Interventions": PillOff,
  "Track Missing or Delayed Data Reporting": DatabaseSearch,
} as const;

export type CategoryKey = keyof typeof CATEGORY_ICONS;
